import { styled } from '@mui/material';

import { CircleImageConsts } from './CircleImage.consts';

type Props = {
  size?: string | number;
};

export const CircleImage = styled('img')<Props>`
  display: block;
  border-radius: 50%;
  object-fit: cover;
  width: ${({ size = CircleImageConsts.defaultSize }) => size};
  height: ${({ size = CircleImageConsts.defaultSize }) => size};
`;
